export default "__VITE_ASSET__DDdjubEA__"